import React from 'react';
import ReactDOM from 'react-dom/client';

// Tailwind CSS (cargar primero)
import './tailwind.css';

// Materialize CSS y JS (legacy - remover cuando se complete la migración)
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';

// Estilos globales
import './index.scss';

// App principal
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
